const BRAND = 'Firesweeper';

function modeName(subtitle: string) {
  return `${BRAND}: ${subtitle}`;
}

/** Fire rules shared by Container and Survivor */
export const SHARED_FIRE_MECHANICS = [
  'Fire spreads to adjacent trees only — up, down, left, or right, never diagonally.',
  'Each burning tree can jump to a random alive square anywhere on the grid.',
  'Burned trees stay burned; flames char to ash after each spread cycle.',
] as const;

/** Turn-based click-to-burn daily puzzle */
export const FIRESWEEPER_CONTAINER = {
  brand: BRAND,
  subtitle: 'Container',
  name: modeName('Container'),
  tagline: 'Hold the line',
  path: '/container',
  resultPath: '/container/result',
  leaderboardPath: '/container/leaderboard',
  description:
    'Everyone gets the same wildfire layout today. Burn firebreaks each turn and save as much forest as you can.',
  features: [
    'One shared daily puzzle — same starting fires for all players',
    'One pre-burn per turn before the fire spreads',
    'Ranked by highest forest survival % today',
  ],
  instructions: [
    'Study the blaze — five trees are already burning.',
    'On your turn, click one alive tree to burn a firebreak.',
    'After each burn, fire spreads automatically. Contain it with forest left to score.',
  ],
  leaderboardHint: 'Highest survival % wins. Ties break by fewest pre-burns, then fastest time.',
} as const;

/** Pick tiles daily survival challenge */
export const FIRESWEEPER_SURVIVOR = {
  brand: BRAND,
  subtitle: 'Survivor',
  name: modeName('Survivor'),
  tagline: 'Pick & endure',
  path: '/survivor',
  resultPath: '/survivor/result',
  leaderboardPath: '/survivor/leaderboard',
  description:
    'Select the trees you believe will outlast today’s blaze. If any chosen tree burns out, you lose instantly.',
  features: [
    'One shared daily wildfire — same starting fires for all players',
    'Pick any tiles, then watch the simulation run',
    'Ranked by most tiles selected on a winning run today',
  ],
  instructions: [
    'Study today’s five starting fires — they’re already burning on the grid.',
    'Tap alive trees to build your portfolio, then hit Start.',
    'If any selected tree becomes fully burned, you lose. Win only if every pick survives.',
  ],
  leaderboardHint: 'Most tiles selected on a win today takes the crown.',
} as const;

/** @deprecated use FIRESWEEPER_CONTAINER */
export const FIRESWEEPER_FIREBREAK = FIRESWEEPER_CONTAINER;

/** @deprecated use FIRESWEEPER_SURVIVOR */
export const FIRESWEEPER_STILL_STANDING = FIRESWEEPER_SURVIVOR;

/** @deprecated use FIRESWEEPER_SURVIVOR */
export const STILL_STANDING = FIRESWEEPER_SURVIVOR;
